<template>
  <div class="q-ma-xs q-mt-xs">
    <div>
      <q-chip v-if="route.params.id.includes('Mis')"
              square
              class="full-width"
              color="info"
              icon="info">Revisa que no tengas recibos en otro Mediador</q-chip>
    </div>
    <DataTable ref="DT"
               :opts="opts"
               @onSelRow="onSelRow"
               @onUpdate="onUpdate">
      <template #buttons>
        <template v-if="sel === true">
          <q-btn v-if="rec.Estado == 'PENDIENTE' || rec.Estado == 'DEVUELTO' || rec.Paso > 0"
                 color="primary"
                 label="Gestionar"
                 @click="gestionar"></q-btn>
          <q-btn v-if="rec.Paso > 0"
                 color="primary"
                 label="Historial"
                 @click="DT.tab = tab = 'tabB'"></q-btn>
          <q-btn v-if="rec.Estado == 'PENDIENTE' || rec.Estado == 'EMITIDO' || rec.Estado == 'DEVUELTO' || rec.Estado == 'COBRADO' || rec.Estado == 'CARTERA'"
                 color="primary"
                 label="Cobrar"
                 @click="DT.tab = tab = 'tabC'"></q-btn>
        </template>
        <template v-if="sel === false && route.params.id === 'Todos'">
          <q-btn-dropdown color="primary"
                          label="Estado Recibo">
            <q-list dense>
              <q-item clickable
                      v-close-popup
                      @click="filtrarPorEstado('TODOS')"
                      :class="{ 'bg-secondary text-white': filtroEstadoActual === 'TODOS' }">
                <q-item-section>TODOS</q-item-section>
              </q-item>
              <q-item clickable
                      v-close-popup
                      @click="filtrarPorEstado('PENDIENTE')"
                      :class="{ 'bg-secondary text-white': filtroEstadoActual === 'PENDIENTE' }">
                <q-item-section>PENDIENTE</q-item-section>
              </q-item>
              <q-item clickable
                      v-close-popup
                      @click="filtrarPorEstado('COBRADO')"
                      :class="{ 'bg-secondary text-white': filtroEstadoActual === 'COBRADO' }">
                <q-item-section>COBRADO</q-item-section>
              </q-item>
              <q-item clickable
                      v-close-popup
                      @click="filtrarPorEstado('ANULADO')"
                      :class="{ 'bg-secondary text-white': filtroEstadoActual === 'ANULADO' }">
                <q-item-section>ANULADO</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </template>
      <template #tabA>
        <q-bar class="bg-secondary text-black rounded-borders">
          {{ rec.Cliente }}
          <q-space></q-space>
          <q-btn color="primary"
                 label="Volver"
                 @click="volver"></q-btn>
        </q-bar>
        <RecibosGestion :opts="rec"
                        :tab="DT.tab"
                        @volver="volver"> </RecibosGestion>
      </template>
      <template #tabB>
        <q-bar class="bg-secondary text-black rounded-borders">
          {{ rec.Cliente }}
          <q-space></q-space>
          <q-btn color="primary"
                 label="Volver"
                 @click="volver"></q-btn>
        </q-bar>
        <RecibosHistorico :opts="rec"
                          :tab="DT.tab"></RecibosHistorico>
      </template>
      <template #tabC>
        <q-bar class="bg-secondary text-black rounded-borders">
          {{ rec.Cliente }}
          <q-space></q-space>
          <q-btn color="primary"
                 label="Volver"
                 @click="volver"></q-btn>
        </q-bar>
        <RecibosCobros :opts="rec"
                       :tab="DT.tab"
                       @update="volver()"> </RecibosCobros>
      </template>
    </DataTable>
    <div class="row"
         v-if="opts.route !== 'Todos' && opts.route !== 'Cartera'">
         <q-chip square dense outline> Recibo: </q-chip>
      <q-chip v-for="(item, index) in info"
              :key="index"
              dense
              square
              :style="{ backgroundColor: item.backColor, color: item.color }"> {{ item.message }}</q-chip>
    </div>
    <div class="row">
      <q-chip square dense outline> Importe: </q-chip>
      <q-chip square dense :style="{background: '#fcf18e', color: 'black'}">PAGO PARCIAL</q-chip>
      <q-chip square dense :style="{background: '#b6ffbf', color: 'black'}">PAGO TOTAL</q-chip>
    </div>
  </div>
</template>

<script setup>
import DataTable from "@/lib/DataTable.vue"
import RecibosGestion from "@/lib/RecibosGestion.vue"
import RecibosHistorico from "@/lib/RecibosHistorico.vue"
import RecibosCobros from "@/lib/RecibosCobros.vue"
import { ref, inject, onMounted, watch } from "vue"
import { useRoute, useRouter } from "vue-router"
const global = inject("global")
const route = useRoute();
const router = useRouter();
// APP
const rec = ref({})
const info = [
  { color: "black", message: " SIN GESTION", backColor: '#fcf18e' },
  { color: "black", message: " CON GESTION", backColor: '#88c9ff' },
  { color: "black", message: " CADUCADO", backColor: '#a8a8a7' },
  { color: "black", message: " URGENTE", backColor: '#f5a9a9' },
  { color: "black", message: " GESTIONADO", backColor: '#b6ffbf' }
]
// DATATABLE
const sel = ref()
const opts = ref({ table: '', url: null, post: null, route: '' })
const DT = ref()
const tab = ref()
const filtroEstadoActual = ref('TODOS')
// DATATABLE FUNCTIONS
function onSelRow(d) {
  if (d !== false) {
    sel.value = true
    rec.value = d
  } else sel.value = false
}
function onUpdate(d) {
  if (route.params.num) { // toma el valor de 1 registro y va a gestionarlo
    if (d.data.length > 0) {
      rec.value = d.data[0]
      DT.value.tab = "tabA"
    }
  }
}
// EMIT
function volver() {
  DT.value.tab = 'grid';
  updateData();
  if (route.params.num) // si existe num en la ruta lo elimina al volver (hay que autoajustar columnas)
    router.push(route.path.split('/').slice(0, -1).join('/'));
}
// PERMISOS PARA GESTIONAR EL RECIBO
function gestionar() {
  if (global.user.grant(rec.value.Responsable)) {
    DT.value.tab = tab.value = 'tabA'
  }
}
// EXTRA FUNCTIONS
async function updateData() {
  const res = await global.db("/app/db/selRecibos", opts.value.post)
  DT.value.updateData(res)
}
function init() {
  filtroEstadoActual.value = "TODOS";
  opts.value = {
    details: [{ key: "Recibo", table: "RecibosGestion" }],
    post: {
      table: "Recibos",
      query: "select",
      where: {
        Mediador: global.user.area
      }
    },
    cols: { "Paso": "Hh" } // Ocultar la columna Paso por defecto
  }
  const { id } = route.params;
  if (id == "PendientesHoy")
    opts.value = {
      ...opts.value,
      post: {
        table: "Recibos",
        query: "RecibosHoy",
        where: {
          ...opts.value.post.where,
          Estado: "PENDIENTE",
          Responsable: global.user.name,
          Fecha: global.data.getDate(-365),
          FechaAgenda: global.data.getDate(0),
          Paso: 90
        }
      }
    }
  if (id == "MisPendientes")
    opts.value = {
      ...opts.value,
      post: {
        ...opts.value.post,
        where: {
          ...opts.value.post.where,
          Responsable: global.user.name,
          Estado: "PENDIENTE"
        }
      }
    }
  if (id == "MisExtornos")
    opts.value = {
      ...opts.value,
      post: {
        table: "Recibos",
        query: "MisExtornos",
        where: {
          ...opts.value.post.where,
          Responsable: global.user.name,
          FechaAgenda: global.data.getDate(0)
        }
      }
    }
  if (id == "Cartera")
    opts.value = {
      ...opts.value,
      locked: true,
      post: {
        ...opts.value.post,
        table: "Recibos_Cartera",
        query: "Cartera",
        cols: { "Poliza": '', "Gestor": '', "Estado": "Hh" }
      }
    };
  updateData();
}
function filtrarPorEstado(estado) {
  filtroEstadoActual.value = estado;
  if (estado === 'TODOS') {
    delete opts.value.post.where.Estado;
    opts.value.group = null;
    if (opts.value.cols && opts.value.cols.Paso) {
      opts.value.cols.Paso = 'Hh'; // Ocultar la columna Paso
    }
  } else {
    opts.value.post.where.Estado = estado;
    opts.value.group = ["Responsable", "Gestion"];
    if (opts.value.cols) {
      opts.value.cols.Paso = ''; // Mostrar la columna Paso
    } else {
      opts.value.cols = { Paso: '' }; // Si cols no existe, crearlo y mostrar Paso
    }
  }
  updateData();
}
onMounted(() => { init() })
watch([route, () => global.user.area], () => { init() });
</script>
<style>
.bg-RO {
  background: #f5a9a9 !important;
}

.bg-VE {
  background: #b6ffbf !important;
}

.bg-AZ {
  background: #88c9ff !important;
}

.bg-AM {
  background: #fcf18e !important;
}

.bg-GR {
  background: #a8a8a7 !important;
}

.text-RO {
  color: #000000 !important;
}

.text-VE {
  color: #000000 !important;
}

.text-AZ {
  color: #000000 !important;
}

.text-AM {
  color: #000000 !important;
}

.text-GR {
  color: #000000 !important;
}
</style>
